export default __webpack_public_path__ + "static/media/i_bus-low_rd_dup.58fe6531.svg";